import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { FileEnums, FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DocumentFormTypes } from "models/formTypes";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const UploadSIEForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  return (
    <GenericForm<DocumentFormTypes.UploadSIE>
      formRef={ref}
      {...props}
      fields={{
        files: {
          label: "",
          type: FormEnums.FormFieldType.FILEUPLOADER,
          extraProps: {
            allowedTypes: [FileEnums.ContentTypes.SIE],
            fileUploaderType: "full",
          },
        },
        comment: {
          label: TranslationKeys.Common.Comment,
          type: FormEnums.FormFieldType.TEXTAREA,
          icon: IconDefinitionConstants.WCommentDots,
        },
      }}
      hideSuccess
    />
  );
};

export default forwardRef(UploadSIEForm);
